import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyCACbRDeA4R635J2s5gajxBRZFJZg-jnx0",
  authDomain: "sawbona-app.firebaseapp.com",
  projectId: "sawbona-app",
  storageBucket: "sawbona-app.firebasestorage.app",
  messagingSenderId: "473710798109",
  appId: "1:473710798109:web:e501998c18722b16182df4",
  measurementId: "G-RXTKTKV56K"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, "us-central1");


export default app;